import { z } from 'zod';

import { AlertTypeSchema } from '@/entities/alert-type';

import { AlertStatusSchema } from './alert-status';

export const AlertsFiltersSchema = z.object({
  changedSinceDays: z.number(),
  groupIds: z.array(z.string()),
  alertStatusList: z.array(AlertStatusSchema),
  alertTypeList: z.array(AlertTypeSchema),
});

export type AlertsFilters = z.infer<typeof AlertsFiltersSchema>;
